import { AuthContextProps } from "react-oidc-context";
import { getHeaders } from "../services/ServiceUtil";
const fetchData = async (
  resource_url: string,
  filters: string = "",
  method: string = "GET",
  auth?: AuthContextProps,
  body?: any // <- support optional request body
) => {
  const baseUrl =
    method === "GET" || method === "DELETE"
      ? `${resource_url}?${filters}`
      : resource_url;

  const headers = auth
    ? {
        Authorization: `Bearer ${auth.user?.access_token}`,
        "Content-Type": "application/json",
      }
    : getHeaders();

  try {
    const response = await fetch(baseUrl, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    // Don't assume response is paginated for non-GET
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export default fetchData;
